/**
 * 语言切换组件
 */
import React from 'react'
import { TranslationOutlined } from '@ant-design/icons'
import { useLanguage } from '@/hooks/useLanguage'

interface LanguageSwitcherProps {
  /** 自定义类名 */
  className?: string
  /** 渲染模式 */
  variant?: 'toggle' | 'toolbar'
}

const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ className, variant = 'toggle' }) => {
  const { currentLanguageInfo, isZhCN, changeLanguage } = useLanguage()

  // 点击切换语言：中文 ↔ 英文
  const handleToggle = () => {
    changeLanguage(isZhCN ? 'en-US' : 'zh-CN')
  }

  if (variant === 'toolbar') {
    return (
      <span
        className={className}
        data-open={isZhCN ? 'true' : 'false'}
        aria-label={currentLanguageInfo.name}
        style={className ? undefined : {
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: isZhCN ? 'var(--color-primary)' : 'var(--color-text-secondary)',
        }}
        onClick={handleToggle}
      >
        <TranslationOutlined style={{ fontSize: 18 }} />
      </span>
    )
  }

  return (
    <span
      className={className}
      data-lang={isZhCN ? 'zh' : 'en'}
      aria-label={currentLanguageInfo.name}
      style={className ? undefined : {
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px',
        minWidth: '78px',
        height: '30px',
        padding: '0 12px',
        borderRadius: '999px',
        border: '1px solid var(--color-border)',
        background: 'var(--color-card)',
        userSelect: 'none',
        lineHeight: 1,
        fontSize: 12,
        fontWeight: 600,
        letterSpacing: '0.3px',
        color: 'var(--color-text-secondary)',
      }}
      onClick={handleToggle}
    >
      <TranslationOutlined style={{ fontSize: 14 }} />
      <span>{currentLanguageInfo.name}</span>
    </span>
  )
}

export default LanguageSwitcher
